// App.js
import React from "react";
import styled from "styled-components";
import Theme from "../../../styles/Theme/Theme";
import clsx from 'clsx';

const Wrapper = styled.div`
  width:100%;
  height: ${(props) => props.$height ? props.$height : 'auto'};
  min-height: ${(props) => props.$minHeight ? props.$minHeight : '200px'};
`;

const Title = styled.div`
  width:100%;
  font-size: ${(props) => props.$fontSize ? props.$fontSize : Theme.typography.fontSize['text_md']};
  font-weight: ${(props) => props.$fontWeight ? props.$fontWeight : null};
  text-align: left;
  margin: 0;
  margin-bottom: ${(props)=> props.$marginBottom ? props.$marginBottom : 0};
  padding: ${(props)=> props.titlePadding ? props.titlePadding : '10px 20px'};
  max-height: 30px;
`;

const Card = styled.div`
  background: ${(props) => props.backgroundColor ? props.backgroundColor : Theme.color['white']};
  border-radius: 10px;
  box-shadow: false;//${(props) => props.boxShadow ? Theme.shadow['shadow-1'] : 'none'};
  border: ${(props) => props.$border ? props.$border : 'none'};
  padding: 20px;
  padding-bottom: ${(props)=> props.$paddingbottom ? props.$paddingbottom : null};
  display: flex;
  flex-wrap: wrap;
  height:100%;
  box-sizing: border-box;
  align-content: flex-start;
  margin-bottom: ${(props) => props.$marginBottom ? props.$marginBottom : null};
  /* gap: 10px; */
`;

const Item = styled.div`
  border-radius: 5px;
  flex: 1 1 calc(33.333% - 10px);
  display: flex;
  align-items: ${(props) => props.align ? props.align : 'center'};
  justify-content: ${(props) => props.justify ? props.justify : 'center'};
  height: calc(100% - 30px);
`;

const Container = ({ title, $fontWeight, $paddingBottom, children,...props}) => {
  return (
    <Wrapper className={clsx('container-wrapper')} $height={props.wrapperHeight} $minHeight={props.wrapperMinHeight}>
      <Card className={clsx('container',props?.className)} $paddingbottom={$paddingBottom} $border='1px solid #E5E5E5' $marginBottom={props.cardMarginBottom}>
        {title ? <Title $fontWeight={$fontWeight} $marginBottom='8px' $fontSize={props.fontSize} titlePadding={props.titlePadding}>{title}</Title> : null}
        
        {props.byItem ? React.Children.map(children, (child, index) => (
          <Item key={index} align={props.alignItem} justify={props.justifyItem}>{child}</Item>
        )) : null}

        {!props.byItem ? children : null}
      </Card>
    </Wrapper>
  );
};

export default Container;
